// src/routes/loginRoute.jsx
import Login from '../pages/Auth/Login';

export const loginRoute = {
  path: '/login',
  element: <Login />
};